<app-breadcrumb></app-breadcrumb>
<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <app-system-wide-message></app-system-wide-message>
            <div class="system-wide-message alert alert-danger alert-dismissible fade show" role="alert" *ngIf="realtime == false">
                <div>There was an error retrieving the real-time data, please try refreshing.</div>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6">
            <div  *ngFor="let route of routes">
                <div class="mx-auto" *ngIf="route.id.toLowerCase() == detailedRoute.id.toLowerCase()">
                    <span class="badge">Status</span><span class="badge badge-danger" [ngClass]="{'suspend-inactive': route.issuspended === false}">Suspended</span><span class="badge badge-danger" [ngClass]="{'suspend-inactive': route.isdelays === false}">Delays</span>
                    <div class="route-label">
                        <div class="route-name">
                            <h2> {{ route.name }} </h2>
                        </div>
                        <div class="route-details">
                            <strong><div class=""> {{ route.description }} </div></strong>
                        </div>
                    </div>
                    <div class="row d-flex p-2 text-center">
                        <nav>
                            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                <a class="nav-item nav-link active" id="nav-alert-tab" data-toggle="tab" href="#nav-alert" role="tab" aria-controls="nav-alert" aria-selected="true">
                                    <div class="status-icons" [ngClass]="{'icon-inactive': route.isalert === false}">
                                        <img class="status-icons" src="../../../assets/images/route-status/alert.png" *ngIf="route.issuspended == false">
                                        <img class="status-icons" src="../../../assets/images/route-status/suspended.png" *ngIf="route.issuspended == true">
                                    </div>
                                    <span class="badge">
                                        Alert
                                    </span>
                                </a>
                                <a class="nav-item nav-link" id="nav-advisory-tab" data-toggle="tab" href="#nav-advisory" role="tab" aria-controls="nav-advisory" aria-selected="false">
                                    <div class="status-icons" [ngClass]="{'icon-inactive': route.isadvisory === false}">
                                        <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
                                    </div>
                                    <span class="badge">
                                        Advisory
                                    </span>
                                </a>
                                <a class="nav-item nav-link" id="nav-detours-tab" data-toggle="tab" href="#nav-detours" role="tab" aria-controls="nav-detours" aria-selected="false">
                                    <div class="status-icons" [ngClass]="{'icon-inactive': route.isdetour === false}">
                                        <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png" *ngIf="route.isweather == true">
                                        <img class="status-icons" src="../../../assets/images/route-status/detour.png" *ngIf="route.isweather == false">
                                    </div>
                                    <span class="badge">
                                        Detour
                                    </span>
                                </a>
                                <a class="nav-item nav-link" id="nav-elevators-tab" data-toggle="tab" href="#nav-elevators" role="tab" aria-controls="nav-elevators" aria-selected="false">
                                    <div class="status-icons" [ngClass]="{'icon-inactive': route.iselevator === false}">
                                        <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
                                    </div>
                                    <span class="badge">
                                        Elevator
                                    </span>
                                </a>
                            </div>
                        </nav>
                    </div>
                    <div class="tab-content" id="nav-tabContent">
                      <div class="tab-pane fade show active pt-3 pb-3 mb-2" id="nav-alert" role="tabpanel" aria-labelledby="nav-alert-tab" [innerHTML]="route.alert"></div>
                      <div class="tab-pane fade pt-3 pb-3 mb-2" id="nav-advisory" role="tabpanel" aria-labelledby="nav-advisory-tab" [innerHTML]="route.advisory"></div>
                      <div class="tab-pane fade" id="nav-detours" role="tabpanel" aria-labelledby="nav-detours-tab">
                          <div *ngFor="let detour of route.detours" class="border-bottom p-2 mb-2">
                              <p><strong>Location: </strong>{{ detour.location_start }}</p>

                              <p><strong>Reason: </strong> {{ detour.reason }}</p>

                              <p><strong>Start</strong>: {{ detour.start }}</p>

                              <p><strong>End</strong>: {{ detour.end }}</p>

                              <p><strong>Message:</strong></p>
                              <p>{{ detour.message }}</p>
                          </div>
                          <div *ngIf="route.detours.length < 1"><p style="padding: 16px 0px; margin: 0px 0px 8px;">There are currently no detours for this route.</p></div>
                      </div>
                        <div class="tab-pane fade pt-3 pb-3 mb-2" id="nav-elevators" role="tabpanel" aria-labelledby="nav-elevators-tab">
                          <div *ngFor="let elevator of route.elevators" class="border-bottom p-2 mb-2">
                            <p>{{ elevator.message }}</p>
                            <span class="badge badge-secondary"> Updated {{ elevator.updated }} </span>
                          </div>
                          <div *ngIf="route.elevators.length < 1"><p>There are currently no elevators out for this route.</p></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6">
                <div>
                    <span class="badge">Map</span>

                    <div class="card mt-2">
                        <div>
                            <app-embedded-map></app-embedded-map>
                        </div>
                    </div>
                </div>
        </div>
      </div>
</div>
<app-main-footer></app-main-footer>
